import { Component, EventEmitter, OnInit, Input, Output, ViewChild, VERSION } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, tap } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';

@Component({
  selector: 'pgh-damage-questionnaire',
  templateUrl: './damage-questionnaire.component.html',
  styleUrls: ['./damage-questionnaire.component.scss']
})
export class DamageQuestionnaireComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() public preSelectedDevice?: PghUserDeviceBase;
  @Input() public isOnboardingFlow?: boolean = false;

  public preHeaderTextContext?: { device:string };

  programCode: string;
  device: PghUserDeviceBase;
  hylaLink: string;
  private deviceInventoryInfo?: InventoryInfoDto;
  private diagnosticDevices?: DeviceDto[];

  public value:string;

  public isDamagedTemplate:boolean = false;

  public damageQuestionnaireForm: UntypedFormGroup;

  constructor(
    public resourceService: ADPResourceService,
    private deviceInventoryService: DeviceInventoryService,
    private selectedDeviceService: SelectedDeviceService,
    private utilityServce: UtilityService,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
  ) { }


  ngOnInit(): void {

    this.device = this.selectedDeviceService.getSelectedDevice();

    this.preHeaderTextContext = { device: buildDeviceDisplayName(this.device)};

    this.damageQuestionnaireForm = new FormGroup({
      selectedDamage: new FormControl('', Validators.required)
    });

  }

  public handleNextEvent() {

    //let data:any[] = [];
    //data.push([]);
    //data[0].imei = this.imeiNumberForm.controls["imeiNumber"].value;

    const selectedDamage = [this.damageQuestionnaireForm.get('selectedDamage').value];

    if (this.damageQuestionnaireForm.valid)
     {
      let data:any[] = [];
      data.push([]);

      if(selectedDamage[0] === 'NODAMAGE'){
        data[0].isDamaged = false;
      }
      else if(selectedDamage[0] === 'DAMAGE'){
        data[0].isDamaged = true;
        this.isDamagedTemplate = true;
      }

      this.nextEvent.emit(data);
    }

    //this.nextEvent.emit();
  }


}
